import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Login = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Erstelle animierte Partikel im Hintergrund
    const newParticles = Array.from({ length: 50 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 4 + 1,
      duration: Math.random() * 20 + 10,
      delay: Math.random() * 5
    }));
    setParticles(newParticles);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post('/api/login', credentials);
      onLogin(response.data.token, response.data.user);
    } catch (error) {
      setError('Ungültige Anmeldedaten');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes gradientShift {
            0%, 100% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
          }

          @keyframes float {
            0%, 100% {
              transform: translateY(0px) translateX(0px);
            }
            33% {
              transform: translateY(-30px) translateX(20px);
            }
            66% {
              transform: translateY(-15px) translateX(-20px);
            }
          }

          @keyframes floatParticle {
            0% {
              transform: translateY(100vh) translateX(0) rotate(0deg);
              opacity: 0;
            }
            10% {
              opacity: 1;
            }
            90% {
              opacity: 1;
            }
            100% {
              transform: translateY(-100vh) translateX(100px) rotate(360deg);
              opacity: 0;
            }
          }

          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateY(50px) scale(0.9) rotateX(10deg);
            }
            to {
              opacity: 1;
              transform: translateY(0) scale(1) rotateX(0deg);
            }
          }

          @keyframes shimmer {
            0% {
              transform: translateX(-100%) translateY(-100%) rotate(45deg);
            }
            100% {
              transform: translateX(100%) translateY(100%) rotate(45deg);
            }
          }

          @keyframes shake {
            0%, 100% { transform: translateX(0); }
            25% { transform: translateX(-10px); }
            75% { transform: translateX(10px); }
          }

          @keyframes glow {
            0%, 100% {
              box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4), 
                          0 0 60px rgba(59, 130, 246, 0.3),
                          inset 0 2px 4px rgba(255, 255, 255, 0.1);
            }
            50% {
              box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4), 
                          0 0 100px rgba(59, 130, 246, 0.5),
                          0 0 40px rgba(139, 92, 246, 0.4),
                          inset 0 2px 4px rgba(255, 255, 255, 0.1);
            }
          }

          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
              opacity: 0.6;
            }
            50% {
              transform: scale(1.5);
              opacity: 0;
            }
          }

          @keyframes rotate {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }

          .login-container {
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, #0f172a 0%, #1e293b 25%, #334155 50%, #1e293b 75%, #0f172a 100%);
            background-size: 400% 400%;
            animation: gradientShift 20s ease infinite;
            padding: 1rem;
            position: relative;
            overflow: hidden;
            perspective: 1000px;
          }

          .login-container::before {
            content: '';
            position: absolute;
            top: -50%;
            left: -50%;
            width: 200%;
            height: 200%;
            background: radial-gradient(circle at 30% 50%, rgba(59, 130, 246, 0.15) 0%, transparent 50%),
                        radial-gradient(circle at 70% 50%, rgba(139, 92, 246, 0.15) 0%, transparent 50%);
            animation: float 25s ease-in-out infinite;
            pointer-events: none;
          }

          .login-container::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 600px;
            height: 600px;
            background: radial-gradient(circle, rgba(59, 130, 246, 0.1) 0%, transparent 70%);
            transform: translate(-50%, -50%);
            animation: pulse 4s ease-in-out infinite;
            pointer-events: none;
          }

          .particle {
            position: absolute;
            background: radial-gradient(circle, rgba(59, 130, 246, 0.8) 0%, rgba(139, 92, 246, 0.4) 50%, transparent 100%);
            border-radius: 50%;
            pointer-events: none;
            filter: blur(1px);
          }

          .orbit-ring {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 800px;
            height: 800px;
            border: 2px solid rgba(59, 130, 246, 0.1);
            border-radius: 50%;
            animation: rotate 60s linear infinite;
            pointer-events: none;
          }

          .orbit-ring::before {
            content: '';
            position: absolute;
            top: 0;
            left: 50%;
            width: 8px;
            height: 8px;
            background: rgba(59, 130, 246, 0.6);
            border-radius: 50%;
            box-shadow: 0 0 20px rgba(59, 130, 246, 0.8);
          }

          .login-card {
            background: rgba(255, 255, 255, 0.95);
            backdrop-filter: blur(20px);
            padding: 3rem 2.5rem;
            border-radius: 24px;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4), 
                        0 0 60px rgba(59, 130, 246, 0.3),
                        inset 0 2px 4px rgba(255, 255, 255, 0.1);
            width: 100%;
            max-width: 420px;
            animation: slideIn 0.8s cubic-bezier(0.4, 0, 0.2, 1), glow 3s ease-in-out infinite;
            position: relative;
            overflow: hidden;
            border: 2px solid rgba(255, 255, 255, 0.2);
            transform-style: preserve-3d;
          }

          .login-card::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, 
              transparent, 
              rgba(59, 130, 246, 0.15), 
              rgba(139, 92, 246, 0.15),
              transparent);
            animation: shimmer 4s infinite;
            pointer-events: none;
          }

          .login-card::after {
            content: '';
            position: absolute;
            top: -50%;
            right: -50%;
            width: 200%;
            height: 200%;
            background: radial-gradient(circle, rgba(59, 130, 246, 0.05) 0%, transparent 70%);
            animation: rotate 20s linear infinite;
            pointer-events: none;
          }

          @keyframes logoFloat {
            0%, 100% {
              transform: translateY(0px) rotateY(0deg);
            }
            50% {
              transform: translateY(-15px) rotateY(5deg);
            }
          }

          @keyframes logoPulse {
            0%, 100% {
              filter: drop-shadow(0 0 30px rgba(59, 130, 246, 0.4)) 
                      drop-shadow(0 0 60px rgba(139, 92, 246, 0.3));
            }
            50% {
              filter: drop-shadow(0 0 50px rgba(59, 130, 246, 0.6)) 
                      drop-shadow(0 0 80px rgba(139, 92, 246, 0.5))
                      drop-shadow(0 0 100px rgba(236, 72, 153, 0.3));
            }
          }

          @keyframes lineExpand {
            0%, 100% {
              width: 60px;
            }
            50% {
              width: 120px;
            }
          }

          .login-logo-container {
            margin-bottom: 2.5rem;
            text-align: center;
            position: relative;
            animation: logoFloat 6s ease-in-out infinite;
            perspective: 1000px;
          }

          .login-logo {
            max-width: 200px;
            height: auto;
            filter: drop-shadow(0 0 30px rgba(59, 130, 246, 0.4)) 
                    drop-shadow(0 0 60px rgba(139, 92, 246, 0.3));
            transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
            animation: logoPulse 4s ease-in-out infinite;
            transform-style: preserve-3d;
          }

          .login-logo-container:hover .login-logo {
            transform: scale(1.15) rotateY(10deg) rotateX(5deg);
            filter: drop-shadow(0 0 60px rgba(59, 130, 246, 0.8)) 
                    drop-shadow(0 0 100px rgba(139, 92, 246, 0.6))
                    drop-shadow(0 0 120px rgba(236, 72, 153, 0.4));
          }

          .login-logo-container::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 250px;
            height: 250px;
            background: radial-gradient(circle, rgba(59, 130, 246, 0.15) 0%, transparent 70%);
            border-radius: 50%;
            animation: pulse 3s ease-in-out infinite;
            pointer-events: none;
            z-index: -1;
          }

          .login-logo-container::after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 60px;
            height: 4px;
            background: linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899);
            border-radius: 2px;
            box-shadow: 0 0 20px rgba(59, 130, 246, 0.6),
                        0 0 40px rgba(139, 92, 246, 0.4);
            animation: lineExpand 3s ease-in-out infinite;
          }

          .login-form {
            display: flex;
            flex-direction: column;
            gap: 1.5rem;
            position: relative;
            z-index: 1;
          }

          .form-group {
            position: relative;
          }

          .form-group::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            width: 0;
            height: 100%;
            background: linear-gradient(90deg, rgba(59, 130, 246, 0.1), transparent);
            border-radius: 12px;
            transition: width 0.4s ease;
            z-index: 0;
          }

          .form-group:focus-within::before {
            width: 100%;
          }

          .form-group input {
            width: 100%;
            padding: 1.1rem 1.5rem;
            border: 2px solid #e2e8f0;
            border-radius: 14px;
            font-size: 1rem;
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            background: rgba(255, 255, 255, 0.9);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
            position: relative;
            z-index: 1;
          }

          .form-group input:focus {
            outline: none;
            border-color: #3b82f6;
            background: white;
            box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15), 
                        0 12px 24px rgba(59, 130, 246, 0.2),
                        0 0 40px rgba(59, 130, 246, 0.1);
            transform: translateY(-3px) scale(1.01);
          }

          .form-group input::placeholder {
            color: #94a3b8;
            transition: color 0.3s;
          }

          .form-group input:focus::placeholder {
            color: #cbd5e1;
          }

          .login-button {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 50%, #1d4ed8 100%);
            color: white;
            border: 2px solid rgba(255, 255, 255, 0.3);
            padding: 1.1rem 2rem;
            border-radius: 14px;
            cursor: pointer;
            font-size: 1.05rem;
            font-weight: 700;
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            box-shadow: 0 10px 20px rgba(59, 130, 246, 0.4), 
                        0 0 40px rgba(59, 130, 246, 0.2),
                        inset 0 2px 4px rgba(255, 255, 255, 0.3);
            position: relative;
            overflow: hidden;
            margin-top: 0.5rem;
            letter-spacing: 0.5px;
            z-index: 10;
          }

          .login-button::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.4);
            transform: translate(-50%, -50%);
            transition: width 0.6s, height 0.6s;
            pointer-events: none;
          }

          .login-button::after {
            content: '';
            position: absolute;
            top: -50%;
            left: -50%;
            width: 200%;
            height: 200%;
            background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);
            animation: shimmer 3s infinite;
            pointer-events: none;
          }

          .login-button:hover::before {
            width: 500px;
            height: 500px;
          }

          .login-button:hover:not(:disabled) {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 50%, #1e40af 100%);
            transform: translateY(-4px) scale(1.03);
            box-shadow: 0 20px 40px rgba(59, 130, 246, 0.5), 
                        0 0 60px rgba(59, 130, 246, 0.4),
                        0 0 100px rgba(59, 130, 246, 0.2);
          }

          .login-button:active:not(:disabled) {
            transform: translateY(-2px) scale(1.01);
          }

          .login-button:disabled {
            opacity: 0.7;
            cursor: not-allowed;
          }

          .error-message {
            color: #dc2626;
            background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
            padding: 1rem 1.25rem;
            border-radius: 12px;
            margin-bottom: 0.5rem;
            font-size: 0.9rem;
            font-weight: 600;
            border: 2px solid #fca5a5;
            animation: shake 0.5s;
            box-shadow: 0 6px 16px rgba(239, 68, 68, 0.3),
                        0 0 30px rgba(239, 68, 68, 0.2);
            position: relative;
            overflow: hidden;
          }

          .error-message::before {
            content: '⚠️';
            margin-right: 8px;
          }

          @keyframes gradientFlow {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }

          @keyframes slideInFromBottom {
            from {
              transform: translateY(20px);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }

          .jigsawcore-badge {
            animation: slideInFromBottom 0.8s ease-out 0.5s backwards;
          }

          .jigsawcore-badge:hover .core-text {
            letter-spacing: 2px;
          }

          .jigsawcore-badge:hover .gear-icon {
            transform: rotate(180deg);
          }

          @media (max-width: 640px) {
            .login-card {
              padding: 2rem 1.5rem;
            }
            .jigsawcore-badge {
              bottom: 1rem !important;
              right: 1rem !important;
            }
            .jigsawcore-badge > div {
              padding: 0.6rem 1rem !important;
            }
          }
        `}
      </style>

      <div className="login-container">
        {/* Orbit Ring */}
        <div className="orbit-ring"></div>

        {/* Floating Particles */}
        {particles.map(particle => (
          <div
            key={particle.id}
            className="particle"
            style={{
              left: `${particle.x}%`,
              bottom: '0',
              width: `${particle.size}px`,
              height: `${particle.size}px`,
              animation: `floatParticle ${particle.duration}s linear infinite`,
              animationDelay: `${particle.delay}s`
            }}
          />
        ))}

        <div className="login-card">
          <div className="login-logo-container">
            <img 
              src="/prosys-logo.png" 
              alt="ProSys Logo" 
              className="login-logo"
            />
          </div>
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <input
                type="text"
                placeholder="Benutzername"
                value={credentials.username}
                onChange={(e) => setCredentials({...credentials, username: e.target.value})}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                placeholder="Passwort"
                value={credentials.password}
                onChange={(e) => setCredentials({...credentials, password: e.target.value})}
                required
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" disabled={loading} className="login-button">
              {loading ? 'Anmelden...' : 'Anmelden'}
            </button>
          </form>
        </div>

        {/* Moderner animierter Footer mit JigSawCore Branding */}
        <div 
          className="jigsawcore-badge"
          style={{
            position: 'fixed',
            bottom: '1.5rem',
            right: '2rem',
            zIndex: 1000
          }}
        >
          <div style={{
            position: 'relative',
            padding: '0.75rem 1.5rem',
            background: 'linear-gradient(135deg, #0f0c29, #302b63, #24243e)',
            backgroundSize: '200% 200%',
            animation: 'gradientFlow 4s ease infinite',
            borderRadius: '50px',
            boxShadow: '0 8px 32px rgba(102, 126, 234, 0.4), inset 0 1px 2px rgba(255, 255, 255, 0.1)',
            border: '1px solid rgba(102, 126, 234, 0.3)',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            overflow: 'hidden'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 12px 40px rgba(102, 126, 234, 0.6), inset 0 1px 2px rgba(255, 255, 255, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 8px 32px rgba(102, 126, 234, 0.4), inset 0 1px 2px rgba(255, 255, 255, 0.1)';
          }}
          >
            {/* Glowing effect overlay */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: '-100%',
              width: '100%',
              height: '100%',
              background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)',
              animation: 'pulse 3s ease-in-out infinite'
            }} />
            
            <div 
              className="gear-icon"
              style={{
                fontSize: '1.2rem',
                filter: 'drop-shadow(0 0 8px rgba(102, 126, 234, 0.8))',
                transition: 'transform 0.6s ease'
              }}
            >
              ⚙️
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.1rem' }}>
              <div style={{
                fontSize: '0.65rem',
                color: 'rgba(255, 255, 255, 0.6)',
                fontFamily: '"Roboto Mono", "Courier New", monospace',
                fontWeight: '500',
                letterSpacing: '1px',
                textTransform: 'uppercase'
              }}>
                ProSys - Projekt System
              </div>
              <div 
                className="core-text"
                style={{
                  fontSize: '0.95rem',
                  fontFamily: '"Orbitron", "Rajdhani", "Roboto", sans-serif',
                  fontWeight: '900',
                  letterSpacing: '0.5px',
                  background: 'linear-gradient(135deg, #667eea 0%, #a78bfa 50%, #ec4899 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  filter: 'drop-shadow(0 0 12px rgba(102, 126, 234, 0.6))',
                  transition: 'letter-spacing 0.3s ease',
                  whiteSpace: 'nowrap'
                }}
              >
                powered by <span style={{ 
                  background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  filter: 'drop-shadow(0 0 16px rgba(251, 191, 36, 0.8))'
                }}>JigSawCore</span>
              </div>
            </div>
            
            {/* Pulse dot */}
            <div style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              background: '#10b981',
              boxShadow: '0 0 12px #10b981',
              animation: 'pulse 2s ease-in-out infinite'
            }} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;